<div class="casino-info-container">
  <div class="casino-header">
    {{ 'Casino_dialog_text_4' | translate }}
  </div>
  <div class="casino-description">
    {{ 'Casino_dialog_text_5' | translate }}
  </div>
  <div class="btn colored green save-changes-button confirm-button" (click)="yesClick()" style="font-size: 12px !important">
    <div class="btn-text">
      {{ 'Confirm' | translate }}
    </div>
  </div>
</div>
